module.exports = __webpack_public_path__ + "img/undefined.e520478c.png";